import React from 'react';
import { useState } from "react";
import { InputMasks } from '@/components/shadcn/ui/input';
import useEstadosECidades from '../../data/estadosECidades';
import { useBusiness } from '@/hook/useBusiness';
import { useEmail } from '@/hook/useEmail';
import logo from './logo/logoNext.png';
import { toast } from '@/components/shadcn/ui/use-toast';
import Modal from './modal';
import { useWhatsapp } from '@/hook/useWhatsapp';


export default function ContactForm() {
  const { createClientBusiness } = useBusiness();
  const { sendEmailCliente } = useEmail()
  const estadosECidades = useEstadosECidades();
  const [estadoSelecionado, setEstadoSelecionado] = useState("");
  const [cidadeSelecionada, setCidadeSelecionada] = useState("");
  const [nome, setNome] = useState("");
  const [telefone, setTelefone] = useState("");
  const [atividade, setAtividade] = useState("")
  const [email, setEmail] = useState("");
  const [data, setData] = useState("");
  const [horainicio, setHorainicio] = useState("");
  const [horafinal, setHorafinal] = useState("");
  const [check, setCheck] = useState(false);
  const [checkSis, setCheckSis] = useState(false);
  const [modalEquipamentos, setModalEquipamentos] = useState(false);
  const [modalERP, setModalERP] = useState(false);
  const [server, setServer] = useState(0);
  const [pc, setPc] = useState(0);
  const [erp, setErp] = useState('');
  const {sendWhatsapp} = useWhatsapp();

  const emailsend = {
    nome: nome,
    telefone: telefone,
    atividade: atividade,
    email: email,
    data: data,
    uf: estadoSelecionado,
    cidade: cidadeSelecionada,
    hora_ini: horainicio,
    hora_fim: horafinal,
  }
  const onAddItem = () => {

    if (nome != '' && atividade != '' && email != '' && telefone != '') {
      let observation = `tipo de atividade: ${atividade}, ${cidadeSelecionada}/${estadoSelecionado}`;

      if (check && !checkSis) {
        observation += ` Equipamentos: ${server} servidores, ${pc} computadores`;
      } else if (!check && checkSis) {
        observation += ` ERP Utilizado: ${erp}`;
      } else if (check && checkSis) {
        observation += ` Equipamentos: ${server} servidores, ${pc} computadores | ERP Utilizado: ${erp}`;
      }
      const response = createClientBusiness({
        description: nome,
        opportunityFlowId: 1,
        email: email,
        observation: observation,
        contactNumber: telefone
      });
      if (response != undefined) {
        const response3 = sendWhatsapp();
        const response2 = sendEmailCliente(emailsend);
        toast({
          description: 'Email enviado com sucesso'
        });
        if (!response2) {toast({description:'ocorreu um erro ao enviar o email'})}
        if(!response3) return;
      }
      if (!response) return;


    }
    else {
      toast({
        description: 'preencha do campos indicado por *'
      })
    }

  }
  const handleCheckEquipamentos = () => {
    setCheck(!check);
    if (!check) {
      setModalEquipamentos(true); // Open modal if checkbox is checked
    }
  };

  const handleCheckERP = () => {
    setCheckSis(!checkSis);
    if (!checkSis) {
      setModalERP(true); // Open modal if checkbox is checked
    }
  };

  return (
    <div>
      <div className="flex md:flex-row justify-between bg-[url('/logo/background.jpg')] bg-no-repeat bg-cover bg-bottom lg:h-screen sm:w-[100%] h-auto flex-col " >
        <div className="m-10 flex justify-items-center items-center flex-col md:flex-row">
          <div className='lg:h-screen'>
            <a href="https://www.nextcompany.com.br/" className="p-0 rounded-full md: m-3">
              <img src={logo} alt="logo nextcompany" className='w-[100px] h-[50px]' />
            </a>
          </div>
          <h2 className="sm:text-xl font-bold mb-2 ml-4 text-cyan-600">Digite seus dados, nós ligamos para você.</h2>
        </div>
        <div className="flex overflow-x-auto justify-center lg:h-[97%] flex-col bg-white shadow-xl p-4 rounded-lg sm:h-[150%] lg:w-3/6 mt-2 ml-6 mr-5  ">
          <label className="block text-sm font-medium mt-2">Seu nome * :</label>
          <input required type="text" className="lg:w-full p-2 border rounded mb-3" value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Digite seu Nome" />

          <label className="block text-sm font-medium">Telefone * :</label>
          <InputMasks required mask="(99) 99999-9999" type="tel" pattern="[0-9]*" value={telefone} onChange={(e: { target: { value: React.SetStateAction<string>; }; }) => setTelefone(e.target.value)} className="lg:w-2/5 p-2 border rounded mb-3 md:w-3/5" placeholder="Digite seu número de telefone" />

          <label className="block text-sm font-medium">Tipo atividade * : </label>
          <input required type="text" className="lg:w-full p-2 border rounded mb-3" value={atividade} onChange={(e) => setAtividade(e.target.value)} placeholder="Digite o tipo de atividade de sua empresa" />

          <label className="block text-sm font-medium">Email * : </label>
          <input required type="text" className="lg:w-full p-2 border rounded mb-3" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Digite seu Email" />

          <label className="block text-sm font-medium">Data para receber a ligação</label>
          <input type="date" className="lg:w-1/3 p-2 border rounded mb-3 md:w-[50%]" value={data} onChange={(e) => setData(e.target.value)} />
          <div className="flex">
            <div className="flex flex-col lg:w-full w-1/3 sm: mr-2">
              <label className="block text-sm font-medium">Estado (UF): </label>
              <select
                className="lg:w-2/3 p-2 border rounded mb-3"
                value={estadoSelecionado}
                onChange={(e) => setEstadoSelecionado(e.target.value)}
              >
                <option value="">Selecione um estado</option>
                {Object.keys(estadosECidades).map((uf) => (
                  <option key={uf} value={uf}>{uf}</option>
                ))}
              </select>
            </div>
            <div className="flex flex-col lg:w-full w-2/3">
              <label className="block text-sm font-medium">Cidade: </label>
              <select
                className="lg:w-full p-2 border rounded mb-3"
                value={cidadeSelecionada}
                onChange={(e) => setCidadeSelecionada(e.target.value)}
                disabled={!estadoSelecionado}
              >
                <option value="">Selecione uma cidade</option>
                {estadoSelecionado && estadosECidades[estadoSelecionado]?.map((cidade) => (
                  <option key={cidade} value={cidade}>{cidade}</option>
                ))}
              </select>
            </div>
          </div>
          <div className='flex m-2'>
            <div className="flex m-2">
              <label className="inline-flex items-center me-5 cursor-pointer">
                <input type="checkbox" className="sr-only peer" checked={check} onChange={handleCheckEquipamentos} />
                <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600 dark:peer-checked:bg-green-600"></div>
                <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Tem equipamentos?</span>
              </label>
              <label className="inline-flex items-center me-5 cursor-pointer">
                <input type="checkbox" className="sr-only peer" checked={checkSis} onChange={handleCheckERP} />
                <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600 dark:peer-checked:bg-green-600"></div>
                <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Utilizou outro sistema ERP?</span>
              </label>
            </div>

          </div>
          <label className="block text-sm font-medium">Horário para receber a ligação</label>
          <p className="text-red-500 text-xs mb-1">*Horário de funcionamento das 8:00 até 18:00 horas.</p>
          <div className="flex gap-2">
            <input value={horainicio} onChange={(e) => setHorainicio(e.target.value)} type="time" className="lg:w-1/4 p-2 border rounded" />
            <input value={horafinal} onChange={(e) => setHorafinal(e.target.value)} type="time" className="lg:w-1/4 p-2 border rounded" />
          </div>

          <button onClick={onAddItem} className="lg:w-full bg-blue-500 text-white p-2 rounded mt-2">Enviar</button>
        </div>
      </div>
      <Modal
        isOpen={modalEquipamentos}
        onClose={() => {
          setModalEquipamentos(false);
          setCheck(false); // Reset checkbox state after modal is closed
        }}
        onSave={() => {
          setModalEquipamentos(false);
        }}
        title="Tem Equipamentos?"
        content={
          <div>
            <p className='mb-3'>Selecione quais e a quantidade de seus equipamentos: </p>
            <div className="flex gap-2">
              <form className="max-w-xs mx-auto">
                <label htmlFor="quantity-input" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Servidores</label>
                <div className="relative flex items-center max-w-[8rem]">
                  <button onClick={() => { if (server > 0) { setServer(server - 1) } }} type="button" id="decrement-button" data-input-counter-decrement="quantity-input" className="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-s-lg p-3 h-11 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none">
                    <svg className="w-3 h-3 text-gray-900 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 2">
                      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h16" />
                    </svg>
                  </button>
                  <input value={server} type="text" id="quantity-input" data-input-counter aria-describedby="helper-text-explanation" className="bg-gray-50 border-x-0 border-gray-300 h-11 text-center text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full py-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="0" required />
                  <button onClick={() => { setServer(server + 1) }} type="button" id="increment-button" data-input-counter-increment="quantity-input" className="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-e-lg p-3 h-11 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none">
                    <svg className="w-3 h-3 text-gray-900 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
                      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 1v16M1 9h16" />
                    </svg>
                  </button>
                </div>
              </form>
              <form className="max-w-xs mx-auto">
                <label htmlFor="quantity-input" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Computadores</label>
                <div className="relative flex items-center max-w-[8rem]">
                  <button onClick={() => { if (pc > 0) { setPc(pc - 1) } }} type="button" id="decrement-button" data-input-counter-decrement="quantity-input" className="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-s-lg p-3 h-11 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none">
                    <svg className="w-3 h-3 text-gray-900 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 2">
                      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h16" />
                    </svg>
                  </button>
                  <input value={pc} type="text" id="quantity-input" data-input-counter aria-describedby="helper-text-explanation" className="bg-gray-50 border-x-0 border-gray-300 h-11 text-center text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full py-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="0" required />
                  <button onClick={() => { setPc(pc + 1) }} type="button" id="increment-button" data-input-counter-increment="quantity-input" className="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-e-lg p-3 h-11 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none">
                    <svg className="w-3 h-3 text-gray-900 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
                      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 1v16M1 9h16" />
                    </svg>
                  </button>
                </div>
              </form>
            </div>
          </div>
        }
      />

      <Modal
        isOpen={modalERP}
        onClose={() => {
          setModalERP(false);
          setCheckSis(false); // Reset checkbox state after modal is closed
        }}
        onSave={() => {
          setModalERP(false);
        }}
        title="Outro Sistema ERP?"
        content={
          <div>
            <p>Se utiliza, ou já utilizou, algum outro sistem ERP, digite o nome no campo abaixo.</p>
            <div className="mt-4 mb-6">
              <label htmlFor="default-input" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Nome do sistema: </label>
              <input value={erp} onChange={(e) => setErp(e.target.value)} type="text" id="default-input" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
            </div>
          </div>
        }
      />
    </div>
  );
}